import { Link } from 'react-router-dom';
import { T } from './Translator';

function PrivacyPolicy() {
  return (
    <div className="main-content legal">
      <h2><T>Privacy Policy</T></h2>
      <p><em><T>Last updated: October 21, 2026</T></em></p>

      <p><T>This Privacy Policy explains how Koplowicz & Sons ("we", "us"), a sole proprietorship based in San Francisco, California, collects and uses information when you visit koplowicz.com (the "Site").</T></p>

      <h3><T>Information we collect</T></h3>
      <ul>
        <li><strong><T>Contact form.</T></strong> <T>If you use the contact form, we receive the name, email address and message you enter. The form is delivered to us by email through EmailJS.</T></li>
        <li><strong><T>Chatbot.</T></strong> <T>If you use the Ask feature, the messages you type are sent to our server and to an AI language model provider so that a reply can be generated. Please do not enter sensitive personal information.</T></li>
        <li><strong><T>Analytics.</T></strong> <T>We use Google Analytics to understand how the Site is used. Google Analytics may collect your IP address, device and browser information, and pages visited, and may set cookies.</T></li>
        <li><strong><T>Translation.</T></strong> <T>If you choose a language other than English, the text of the page you are viewing is sent to the Google Cloud Translation API to be translated.</T></li>
        <li><strong><T>Server logs.</T></strong> <T>Our hosting provider may keep standard logs, such as IP address and requested pages, for security and troubleshooting.</T></li>
      </ul>

      <h3><T>How we use information</T></h3>
      <p><T>We use this information to respond to your messages, operate and improve the Site, keep it secure, and understand how it is used. We do not sell your personal information.</T></p>

      <h3><T>Third-party services</T></h3>
      <p><T>We rely on the following providers, each of which has its own privacy policy: Google (Analytics and Cloud Translation), EmailJS, DigitalOcean (hosting), and our AI language model provider for the chatbot.</T></p>

      <h3><T>Cookies</T></h3>
      <p><T>The Site itself does not set cookies. Google Analytics may set cookies in your browser. You can block or delete cookies in your browser settings, or install the Google Analytics opt-out browser add-on.</T></p>

      <h3><T>Retention</T></h3>
      <p><T>We keep contact form messages for as long as needed to respond to you and for ordinary business records. You can ask us to delete your information at any time.</T></p>

      <h3><T>Your choices and rights</T></h3>
      <p><T>You may ask us to access, correct or delete the personal information we hold about you. California residents may have additional rights under the California Consumer Privacy Act. To make a request, contact us using the details below.</T></p>

      <h3><T>Children</T></h3>
      <p><T>The Site is not directed to children under 13, and we do not knowingly collect their personal information.</T></p>

      <h3><T>Changes to this policy</T></h3>
      <p><T>We may update this policy from time to time. The date at the top shows when it was last changed.</T></p>

      <h3><T>Contact us</T></h3>
      <p><T>Questions about this policy? Please use the </T><Link to="/contact"><T>contact form</T></Link><T> or call 707-456-7743.</T></p>
    </div>
  );
}

export default PrivacyPolicy;
